
import { BaseOauthClient, OauthConfig } from "./base";
import { AirtableOauthClient } from "./airtable";
import { GoogleSheetsOauthClient } from "./google_sheets";
import { HubspotOauthClient } from "./hubspot";
import { XeroOauthClient } from "./xero";
import { ShopifyOauthClient } from "./shopify";

export const OauthClients: { [key: string]: typeof BaseOauthClient } = {
    airtable: AirtableOauthClient,
    google_sheets: GoogleSheetsOauthClient,
    hubspot: HubspotOauthClient,
    xero: XeroOauthClient,
    shopify: ShopifyOauthClient,
}

export {
    BaseOauthClient,
    AirtableOauthClient,
    GoogleSheetsOauthClient,
    HubspotOauthClient,
    XeroOauthClient,
    ShopifyOauthClient
};
export type { OauthConfig };
